module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M7 4h2a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1zm16 0h2a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1zm9 6V2a2 2 0 0 0-2-2h-1a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V1a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V1a1 1 0 0 0-1-1H2a2 2 0 0 0-2 2v8h32zM0 14v16a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V14H0z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/calendar-1.js
// module id = 1033
// module chunks = 14